<script setup>
import {onBeforeMount, ref, reactive} from "vue";
import YTCard from "@/components/YTCard/YTCard.vue";
import {getRoute} from "@/hooks/getRoute.js";
import moment from "moment"
import router from "@/router/index.js";
import {detailOrder, updateOrderState} from "@/api/order/order.js";
import {orderTriggerEnum} from "@/enum/orderStateEnum.js"
import YTOrderState from "@/components/YTOrderState/index.vue"
import YTCheckedPanel from "@/components/YTCheckedPanel/index.vue"
import YTDrawerItem from "@/components/YTDrawerItem/YTDrawerItem.vue";
import YTDrawerMember from "@/components/YTDrawerMember/YTDrawerMember.vue";
import {detailMember} from "@/api/member/member.js";
import {itemDetail} from "@/api/goods/goods.js";

// 路由信息
const {route} = getRoute();

// 是否有订单id
const hasOrderId = ref(false)
// 加载状态
const loading = ref(false)
onBeforeMount(async () => {
  hasOrderId.value = Boolean(route.query.orderId)
  // 检测是否携带订单id
  if (!hasOrderId.value) {
    loading.value = true
    ElMessage.error("暂无订单信息")
    return
  }
  await handleSearch()
})

// 获取订单信息
const handleSearch = async () => {
  try {
    loading.value = true
    const res = await detailOrder(route.query.orderId)
    formData.orderId = res.orderId
    formData.storeName = res.storeName
    formData.storeId = res.storeId
    formData.orderTime = moment(res.orderTime).format("YYYY-MM-DD HH:mm:ss")
    console.log("res.orderTime", res.orderTime)
    console.log("formData.orderTime", formData.orderTime)
    formData.nickname = res.nickname
    formData.memberId = res.memberId
    formData.phone = res.phone
    formData.orderItemList = res.orderItemList
    formData.originalAmount = res.originalAmount
    formData.payableAmount = res.payableAmount
    formData.orderNo = res.orderNo
    formData.orderState = res.orderState
    // 处理当前订单允许更改的状态列表
    formData.allowedTriggers = res.allowedTriggers
    formData.propertyGroupList = res.propertyGroupList
    triggerList.value = []
    formData.allowedTriggers.forEach(i => {
      const has = orderTrigger.value.find(r => r.stateId === i)
      if (has) {
        let param = {
          value: has.stateId,
          name: has.stateName
        }
        triggerList.value.push(param)
      }
    })
    formData.goodsType = res.goodsType
    loading.value = false
  } catch (e) {
    console.log(e)
  }
}

/*订单相关*/
const orderTrigger = ref(orderTriggerEnum)
const triggerList = ref([])
// 订单详情信息
const formData = reactive({
  orderId: null,
  storeName: null,
  orderTime: null,
  nickname: null,
  memberId: null,
  phone: null,
  orderItemList: [],
  originalAmount: 0,
  payableAmount: 0,
  orderNo: null,
  paymentMethod: "微信支付",
  orderState: null,
  allowedTriggers: [],
})
// 用户信息抽屉打开状态
const drawer = ref(false)
// 处理点击用户名称跳转
const handleCustomerDetail = async (id) => {
  drawer.value = true
  drawerCacheType.value = 1
  drawerLoading.value = true
  drawerCacheInfo.value = await detailMember(id)
  drawerLoading.value = false
}
// 处理点击活动信息跳转
const handleActivityDetail = async (id) => {
  drawer.value = true
  drawerCacheType.value = 2
  drawerLoading.value = true
  drawerCacheInfo.value = await itemDetail(id)
  drawerLoading.value = false
}
// 处理关闭用户信息抽屉
const handleCloseDrawer = () => {
  drawer.value = false
  drawerCacheType.value = null
  drawerCacheInfo.value = null
}
// 抽屉缓存类型
const drawerCacheType = ref(null)
// 抽屉缓存信息
const drawerCacheInfo = ref(null)
// 抽屉缓存加载状态
const drawerLoading = ref(false)

/*保存修改相关*/
// 保存内容提交表单
const submit = async (type) => {
  try {
    loading.value = true
    const param = {
      orderTrigger: type
    }
    await updateOrderState(formData.orderId, param)
    loading.value = false
    ElMessage.success("修改订单状态成功")
    router.push("/listOnlineStoreOrder")
  } catch (e) {
    console.log(e)
  }
}

/*页面动画相关*/
// 基本信息锚点
const baseRef = ref()

/*更新状态相关*/
// 多选弹窗打开状态
const open = ref(false)
// 处理多选框取消
const handleCancelPanel = () => {
  open.value = false
}
// 处理多选框确认
const handleConfirmPanel = async (val) => {
  await submit(val[0])
  open.value = false
}
</script>

<template>
  <el-form
      :model="formData"
      label-position="right"
      label-width="100px"
      v-loading="loading"
  >
    <div class="container_box mg_b_2" style="padding-bottom: 0;">
      <YTCard ref="baseRef" :title="'基本信息'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item-three-line"
          >
            <div>
              <el-form-item label="订单编号：" prop="orderId">
                <el-text class="mx-1" v-text="formData.orderId"></el-text>
              </el-form-item>
              <el-form-item label="网店：" prop="storeName">
                <el-text class="mx-1" v-text="formData.storeName"></el-text>
              </el-form-item>
              <el-form-item label="时间：" prop="orderTime">
                <el-text class="mx-1" v-text="formData.orderTime"></el-text>
              </el-form-item>
              <el-form-item label="用户：" prop="customerName">
                <el-link type="primary" v-text="`${formData.nickname}（${formData.phone}）`" :underline="false" @click="handleCustomerDetail(formData.memberId)"></el-link>
              </el-form-item>
            </div>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div class="container_box mg_b_2" style="padding-bottom: 0">
      <YTCard :title="'商品信息'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item-avatar-three-line"
          >
            <div class="w-100 mx-5" v-if="formData.orderItemList.length > 0">
              <div class="cursor-pointer" @click="handleActivityDetail(item.goodsId)" v-for="(item, index) in formData.orderItemList" :key="`goodsInfo${index}`">
                <div class="flex">
                  <el-image class="mg_r_1" style="width: 100px; height: 100px" :src="item.goodsImage" :fit="'contain'" />
                  <div class="flex_align_t flex_warp flex_1">
                    <div class="w-100">
                      <strong>
                        <el-text class="mx-1" size="large" v-text="item.goodsName"></el-text>
                      </strong>
                      <div>
                        <el-text class="mx-1" type="info" size="small" v-text="item.desc"></el-text>
                      </div>
                    </div>
                    <div class="flex_bt w-100" style="align-self: flex-end">
                      <el-text class="mx-1" size="large" v-text="`数量：${item.quantity}`"></el-text>
                      <el-text class="mx-1" size="large" v-text="`￥${item.totalAmount}`"></el-text>
                    </div>
                  </div>
                </div>
                <v-divider style="margin: 24px 0"/>
              </div>
            </div>
            <div class="w-100 mx-5 tips_default txt_center" v-else>
              暂无商品信息
            </div>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div class="container_box mg_b_2" style="padding-bottom: 0">
      <YTCard :title="'支付信息'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item-three-line"
          >
            <div>
              <el-form-item label="商品总价：" prop="originalAmount">
                <el-text class="mx-1" v-text="formData.originalAmount"></el-text>
              </el-form-item>
              <el-form-item label="实付金额：" prop="payableAmount">
                <el-text class="mx-1" v-text="formData.payableAmount"></el-text>
              </el-form-item>
              <el-form-item label="交易编号：" prop="orderNo">
                <el-text class="mx-1" v-text="formData.orderNo"></el-text>
              </el-form-item>
              <el-form-item label="支付类型：" prop="paymentMethod">
                <el-text class="mx-1" v-text="formData.paymentMethod"></el-text>
              </el-form-item>
            </div>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div class="container_box mg_b_2" style="padding-bottom: 0">
      <YTCard :title="'订单状态'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item"
          >
            <el-form-item label="订单状态：" prop="orderState">
              <YTOrderState class="mg_r_2" :state="formData.orderState"></YTOrderState>
              <v-btn color="success" @click="open = true" v-if="formData.allowedTriggers.length > 0" :disabled="!$handleHasBtnPermission('all', 'onlineOrderAdmin:edit')">更新状态</v-btn>
            </el-form-item>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div>
      <v-row>
        <v-col>
          <v-btn @click="router.back()">返回</v-btn>
        </v-col>
      </v-row>
    </div>
  </el-form>
  <YTCheckedPanel
      v-if="open"
      :open="open"
      :title="'订单状态'"
      :list="triggerList"
      :hasAll="false"
      :checked-limit="1"
      @cancel="handleCancelPanel"
      @confirm="handleConfirmPanel">
  </YTCheckedPanel>
  <el-drawer
      v-model="drawer"
      :title="drawerCacheType === 1 ? '用户信息' : '活动信息'"
      direction="rtl"
      :close="handleCloseDrawer"
      style="text-align: left"
      :size="drawerCacheType === 1 ? '30%' : '50%'"
  >
    <el-skeleton v-if="drawerLoading" :rows="5" animated />
    <div v-else>
      <div v-if="drawerCacheType === 1">
        <YTDrawerMember :drawer-cache-info="drawerCacheInfo"></YTDrawerMember>
      </div>
      <div v-else>
        <YTDrawerItem :drawer-cache-info="drawerCacheInfo"></YTDrawerItem>
      </div>
    </div>
  </el-drawer>
</template>

<style scoped>

</style>